import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class VideoComponent  implements OnInit {
  @Input() videoLink: string = '';
  invalidLink = false;

  @Output() inputChange = new EventEmitter<{
    videoLink: string;
  }>();
  constructor() {}

  ngOnInit() {
    const formattedActualite = JSON.parse(localStorage.getItem('formattedActualite') || '{}');
    if (!formattedActualite.articleBlocks) {
      return;
    }
    const block = formattedActualite.articleBlocks.find((block: any) => block.type === 5);
    if (block) {
      this.videoLink = block.content.videoLink;
      this.onInputChange();
    }
  }

  onInputChange() {
    const videoId = this.videoLink.slice(-11);

    if (videoId.length < 11) {
      this.invalidLink = true;
    } else {
      this.invalidLink = false;
      this.videoLink = `https://www.youtube.com/embed/${videoId}`;
      this.inputChange.emit({
        videoLink: this.videoLink,
      });
    }
  }
}
